/** @jsxImportSource @emotion/react */
import { Dialog } from "@headlessui/react";
import { QuestionMarkCircleIcon } from "@heroicons/react/outline";
import { XIcon } from "@heroicons/react/solid";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "twin.macro";
import tw from "twin.macro";
import { Transition } from "../shared/Transition";


export const RegisterMetroHelperModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        static
        tw="fixed z-50 inset-0 overflow-y-auto"
        open={isOpen}
        onClose={onClose}
        onClick={onClose}
      >
        <div tw="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter={tw`ease-out duration-300`}
            enterFrom={tw`opacity-0`}
            enterTo={tw`opacity-100`}
            leave={tw`ease-in duration-200`}
            leaveFrom={tw`opacity-100`}
            leaveTo={tw`opacity-0`}
          >
            <Dialog.Overlay tw="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span tw="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            tw="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl sm:my-8 sm:align-middle max-w-lg w-full sm:p-6 transform transition-all"
            enter={tw`ease-out duration-300`}
            enterFrom={tw`opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95`}
            enterTo={tw`opacity-100 translate-y-0 sm:scale-100`}
            leave={tw`ease-in duration-200`}
            leaveFrom={tw`opacity-100 translate-y-0 sm:scale-100`}
            leaveTo={tw`opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95`}
          >
            <div tw="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                tw="bg-white p-0.5 rounded-md text-gray-400 hover:(bg-gray-50 text-gray-500) focus:(outline-none bg-gray-50 text-gray-500)"
                onClick={onClose}
              >
                <span tw="sr-only">{t("shared.close")}</span>
                <XIcon tw="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div>
              <div tw="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100">
                <QuestionMarkCircleIcon tw="h-6 w-6 text-gray-600" aria-hidden="true" />
              </div>
              <div tw="mt-3 text-center sm:mt-5">
                <Dialog.Title as="span" tw="text-sm leading-6 text-gray-900">
                  {t("auth.helper-metro-id")}
                </Dialog.Title>
                <div tw="mt-2">
                  <img src={`${process.env.PUBLIC_URL}/helper/register_metro_helper.png`}>
                  </img>
                  {/* <video width="750" height="500" loop autoPlay >
                  <source src={`${process.env.PUBLIC_URL}/helper/register_metro_helper.webm`} type="video/webm" />
                </video> */}
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
